import { serializable } from 'serializr';
import TcFileBase from './../shared/tcfile-base';
import { observable, computed } from 'mobx';
import moment from 'moment';
import _ from 'lodash';

export default class TcFileModel extends TcFileBase {
    constructor(...args) {
        super(...args);
        this.survey = false;
        this.hud = false;
        this.thumbDrive = false;
    }

    @serializable coordinator = {};
    @serializable @observable agents = [];

    @computed
    get isNew() {
        return this.tcFileId === 'new' || this.tcFileId === null;
    }

    @computed
    get agent() {
        const agent = this.agents.length > 0 ? this.agents[0] : null;
        if (!agent) agent.firstName = agent.name.split(' ');
        return agent;
    }

    @computed
    get isTransaction() {
        return _.isFinite(this.transactionId);
    }

    @computed
    get showEscrowWarning() {
        return (
            !(this.actualCloseDate && moment(this.actualCloseDate).isValid()) &&
            moment().isAfter(moment(this.estimatedCloseDate).subtract(5, 'days'))
        );
    }
}



// WEBPACK FOOTER //
// ./src/files/tcfile-model.js